/** Window events for the full-height right-side Morpho Chat panel. */

export const openAiChatPopout = () => {
	window.dispatchEvent(new CustomEvent("openAiChatPopout"));
};

export const closeAiChatPopout = () => {
	window.dispatchEvent(new CustomEvent("closeAiChatPopout"));
};

export const toggleAiChatPopout = () => {
	window.dispatchEvent(new CustomEvent("toggleAiChatPopout"));
};
